import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "routeDetail" }
const _hoisted_2 = { class: "routeWrapper" }

import { Skeletor } from 'vue-skeletor';
import { PortList, ServiceStatus } from '..';
import { ServiceStatusType } from '../../types/ServiceStatusType';
import { Port } from '../../types';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'RouteDetail',
  props: {
    status: {},
    ports: {},
    destinationName: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.status && !_ctx.isLoading)
          ? (_openBlock(), _createBlock(_unref(ServiceStatus), {
              key: 0,
              status: _ctx.status
            }, null, 8, ["status"]))
          : (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_unref(Skeletor), {
                key: 1,
                class: "vue-skeletor-status"
              }))
            : _createCommentVNode("", true),
        _createVNode(_unref(PortList), {
          ports: _ctx.ports,
          "is-loading": _ctx.isLoading,
          "destination-name": _ctx.destinationName
        }, {
          favourite: _withCtx(() => [
            _renderSlot(_ctx.$slots, "favourite")
          ]),
          _: 3
        }, 8, ["ports", "is-loading", "destination-name"])
      ]),
      _renderSlot(_ctx.$slots, "lastUpdated"),
      _renderSlot(_ctx.$slots, "infoCard")
    ])
  ]))
}
}

})